import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function Field({ label, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium">{label}</Label>
      {children}
    </div>
  );
}

export function TextField({ label, value, onChange, type = "text", placeholder = "", testid, className }) {
  return (
    <Field label={label} className={className}>
      <Input type={type} value={value ?? ""} placeholder={placeholder} data-testid={testid}
        onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} />
    </Field>
  );
}

export function AreaField({ label, value, onChange, testid, rows = 3 }) {
  return (
    <Field label={label}>
      <Textarea value={value ?? ""} rows={rows} data-testid={testid} onChange={(e) => onChange(e.target.value)} />
    </Field>
  );
}

export function SelectField({ label, value, onChange, options, testid }) {
  return (
    <Field label={label}>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Select…" /></SelectTrigger>
        <SelectContent>
          {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
  );
}

export function StatCard({ label, value, icon: Icon, accent }) {
  return (
    <div className="bg-card border border-border rounded-md p-5 transition-transform duration-200 hover:-translate-y-1 hover:shadow-sm" data-testid={`stat-${label.toLowerCase().replace(/ /g, "-")}`}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground font-medium">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${accent || "text-accent"}`} />}
      </div>
      <div className="font-display text-2xl font-bold tabnum text-foreground">{value}</div>
    </div>
  );
}
